import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../services/AuthService";
import {ActivatedRoute, Route, Router} from "@angular/router";

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit {
  constructor(protected authService: AuthService,
              private route: ActivatedRoute,
              private router: Router) {
    this.authService.checkRedirect(this.route.snapshot).then((result) => {

        if (result && !window.location.href.includes("localhost"))
          document.location.href = 'https://connect.cubedcon.com/goto/staff';
        else if(router.lastSuccessfulNavigation === null || router.lastSuccessfulNavigation.id === 1)
          router.navigate(['/'])
    });
  }

  ngOnInit() {

  }
}
